import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import {
  Auth, SatCoreComponent, accommodationsManager, appManager, assignmentManager,
  classroomManager, contentManager, courseManager, dialogManager, gradebookManager,
  i18nAddSatellite, isProductionEnvironmentUrl, libraryManager, navigationManager, reportOverrideManager, studentProgressManager, topNavManager, userManager
} from 'sat-core';
import { API_ROOT, LESSON_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE } from './api-config';

import icon_usa from './img/cognia-usa-map.png';

import 'semantic-ui-less/semantic.less';
import './index.less';
import * as serviceWorker from './serviceWorker';

/* Put component override imports here */
import './views/MainViewOverride';
import './views/LoginOverride';
import './views/ProgressViewOverride';
import './components/CourseListBannerOverride';

import cogniaTranslations from './cogniaTranslations';

i18nAddSatellite('cognia', cogniaTranslations);

const App = SatCoreComponent('App');

const logo = undefined; // handled via css

Auth.init(API_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE, logo, LESSON_ROOT);

accommodationsManager.setIncludeClassroomAccommodations(true);
appManager.init({ classWorkspaceFeature: true });
assignmentManager.setEnableCourseSearch(true);
assignmentManager.setLateSubmissionOptionAllowed(true);
classroomManager.setEnabledStudentsOnly(false);
classroomManager.setIncludeGroups(true);
contentManager.setResourceIFrameUrl('https://interimassessments.onlinehelp.cognia.org/');
contentManager.setResourceIFrameUrlStudent('https://www.cognia.org/tools-resources');
gradebookManager.setAllowAssignmentLink(true);
gradebookManager.setAllowGradebookStandards(true);
gradebookManager.setExternalReportButton({
  url: isProductionEnvironmentUrl(window.location.origin) ? 'https://scale.content2classroom.com' : 'https://scale.content2classroom.com?qa=true',
  label: 'External Report',
  params: {
    classroomId: 'classroomId',
    contentItemId: 'contentItemId'
  }
});
navigationManager.setAllowCarouselAdaptiveHeight(true);
studentProgressManager.setAllowStudentProgressNavTab(true);
userManager.setAllowStudentUsernamesAsEmail(true);
userManager.setAllowViewSatelliteProductTab(true);
userManager.setClientPrefix('COG');
libraryManager.setAllowDigitalItemBanking(true);
libraryManager.setAllowPrintItemBanking(false);
reportOverrideManager.setReportTypeSelectorViewIconOverride({
  standardsIcon: icon_usa
});
topNavManager.setStudentTopNavOrderArray(['courses','assignments', 'progress']);
topNavManager.setStudentMainTopNavId('courses');

ReactDOM.render(
  <Provider
    assignmentManager={assignmentManager}
    classroomManager={classroomManager}
    contentManager={contentManager}
    courseManager={courseManager}
    dialogManager={dialogManager}
    gradeBookManager={gradebookManager}
    navigationManager={navigationManager}
    userManager={userManager}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
